import { all } from "redux-saga/effects";
import widgetsSaga from "./widgets";
import expensesListsSaga from "./expensesLists";
import capitalSaga from "./capital";
import capitalDetailsSaga from "./capitalDetails";
import savingsSourcesSaga from "./savingsSources";
import customStocksSaga from "./customStocks";
import sharedSaga from "./shared";

function* rootSaga() {
  yield all([
    widgetsSaga(),
    expensesListsSaga(),
    capitalSaga(),
    capitalDetailsSaga(),
    savingsSourcesSaga(),
    customStocksSaga(),
    sharedSaga(),
  ]);
}

export default rootSaga;
